import React from "react";
var __jsx = React.createElement;
import stl from "./SpecialCarsComponent.module.css";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import GrantedPopup from "../../../../../components/SearchComponent/NewComponents/GrantedPopup/GrantedPopup";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import { Fragment, useState } from "react";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import { ModernCard } from "@/components/SearchComponent/ModernCard";
var SpecialCarsComponent = function SpecialCarsComponent(_ref) {
  var posts = _ref.posts;
  var _useTranslation = useTranslation(["web_services", "web_common"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useState = useState(false),
    showGrantedPopup = _useState[0],
    setShowGrantedPopup = _useState[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.services_postsContainer
  }, posts.length ? posts === null || posts === void 0 ? void 0 : posts.map(function (post, idx) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: idx
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModernCard, {
      post: post,
      key: post.id,
      showGrantedPopup: function showGrantedPopup() {
        return setShowGrantedPopup(true);
      },
      rank: idx + 1,
      titleTag: "h3"
    })));
  }) : /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 325,
    numberOfLoaders: "4",
    hasCar: true
  })), /*#__PURE__*/React.createElement("a", {
    href: createUrl("/autos"),
    className: [stl.toAutos, "redBtn", "notWebViewBtn"].join(" ")
  }, t("browse_cars", {
    ns: "web_services"
  })), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: showGrantedPopup,
    onClose: function onClose() {
      return setShowGrantedPopup(false);
    }
  }, /*#__PURE__*/React.createElement(GrantedPopup, null)));
};
export default SpecialCarsComponent;